import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import Arrow from '../../images/long-arrow-right.svg'

const InterventionService = () => {
    return ( <section
        id="intervention-service">
        <Container>
          <Row>
            <Col md={6} className="service-txt-wrapper">
              <div className="title-txt">
                Find the Best Rehab Centre for You
              </div>
              <h1>
                Intervention <br/> Services
              </h1>
              <p>Are you seeking treatment options for a family member and looking for professional help? Search below to find qualified professional intervention services that can assist you in helping your loved one.</p>
            </Col>
            <Col md={5} className="offset-md-1 text-center my-auto">
              <button className="service-btn btn">All Intervention Services<span className="pl-3"><img src={Arrow} alt=""/></span></button>
            </Col>
          </Row>
        </Container>
        </section> );
}
 
export default InterventionService;